define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "./template/taskWizardLocaleStepsPageTemplate.html",
], function (Marionette, $, Messenger, Properties, TaskWizardLocaleStepsPageTemplate) {
  "use strict";

  var TaskWizardLocaleStepsPageView = {};

  TaskWizardLocaleStepsPageView.localeStepsPageView = Marionette.Layout.extend({
    className: "form-horizontal task-wizard-locale-steps",
    template: TaskWizardLocaleStepsPageTemplate,
    regions: {
      taskSteps: ".task-steps",
    },
    events: {
      "change .task-locales": function (e) {
        var languageId = $(e.target).val();
        this.trigger("change:locale", {
          view: this,
          model: this.model,
          value: +languageId,
        });
      },
    },
    ui: {
      taskDescription: ".task-description",
      taskDescriptionError: ".task-description-error",
      taskLocalesError: ".task-locales-error",
      taskName: ".task-name",
      taskNameError: ".task-name-error",
    },
    clearErrors: function () {
      this.ui.taskDescriptionError.html("");
      this.ui.taskNameError.html("");
      this.ui.taskLocalesError.html("");
    },
    descriptionError: function (message) {
      this.ui.taskDescriptionError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    localesError: function (message) {
      this.ui.taskLocalesError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    nameError: function (message) {
      this.ui.taskNameError
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    getTaskDescription: function () {
      var value = this.ui.taskDescription.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskDescription.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTaskName: function () {
      var value = this.ui.taskName.val();
      var trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskName.val(trimmedValue);
      }
      return trimmedValue;
    },
  });

  return TaskWizardLocaleStepsPageView;
});
